import { render, staticRenderFns } from "./VuesticSlider.vue?vue&type=template&id=56c9f79c"
import script from "./VuesticSlider.vue?vue&type=script&lang=js"
export * from "./VuesticSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c9f79c')) {
      api.createRecord('56c9f79c', component.options)
    } else {
      api.reload('56c9f79c', component.options)
    }
    module.hot.accept("./VuesticSlider.vue?vue&type=template&id=56c9f79c", function () {
      api.rerender('56c9f79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-slider/VuesticSlider.vue"
export default component.exports